var StringBuffer = function() {
	this.buffer = "";
};

StringBuffer.prototype.prepend = function (str) {
	this.buffer = str + this.buffer;
	return this;
};
StringBuffer.prototype.append = function (str) {
	this.buffer += str;
	return this;
};
StringBuffer.prototype.getString = function () {
	return this.buffer;
};
StringBuffer.prototype.reset = function () {
	this.buffer = "";
};

module.exports = StringBuffer;


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/StringBuffer.js